<template>
  <div class="modal" id="modal-delete-coupon" tabindex="-1" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            Delete Coupon #{{ coupon.id }}
          </h5>
        </div>

        <div class="modal-body">
          Are you sure you want to delete this Coupon?
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">No, Go Back</button>

          <button type="button"
                  @click="deleteCoupon"
                  class="btn btn-danger">
            Yes, Delete
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['coupon'],

  /**
   * The component's data.
   */
  data () {
    return {
      deleteCouponForm: new AppForm({}),
    };
  },

  methods: {
    /**
     * Delete the given Coupon.
     */
    deleteCoupon () {
      App.delete('/api/coupons/' + this.coupon.id, this.deleteCouponForm)
        .then(() => {
          $('#modal-delete-coupon').modal('hide');
          this.$parent.$emit('deleteCoupon');
          this.$parent.$emit('updateCoupons');
        });
    },
  }
};
</script>
